import { Col, Modal, ModalBody, ModalHeader, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const BaggageWarning = ({ isOpen, toggle, handleBooking, flight }) => {
    const { t } = useTranslation();
    return (
        <Modal
            show={isOpen}
            onHide={toggle}
            size="lg"
            id="cancellation"
            aria-hidden="true"
            className="w-[99%] fade h-screen"
        >
            <ModalHeader>
                <h5 className="modal-title">Important</h5>
                <button type="button" onClick={toggle} className="btn-close" />
            </ModalHeader>
            <ModalBody className="p-3">
                <h6 className="text-center text-lg">{t("baggageWarning")}</h6>
                <Row className="g-3 justify-content-center m-4">
                    <Col xs={6} sm={4}>
                        <button
                            onClick={toggle}
                            className="btn btn-outline-danger w-100"
                        >
                            Cancel
                        </button>
                    </Col>
                    <Col xs={6} sm={4}>
                        <button
                            onClick={() => {
                                handleBooking(flight);
                            }}
                            className="btn text-white  bg-main-color w-100"
                        >
                            Continue
                        </button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};

export default BaggageWarning;
